<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Pest/Disease', apiMethod: 'Afflictions', form: () => import('../forms/AfflictionForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Pest/Disease Test', apiMethod: 'AfflictionTests', parentForeignKey: 'afflictionId', form: () => import('../forms/AfflictionTestForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Sightings', value: 'afflictionId', table: () => import('../tables/AfflictionSightingsTable') },
                    { text: 'Tests', value: 'afflictionId', isCard: true, table: () => import('../tables/AfflictionTestsTable') },
                    { text: 'Biosecurity Incidents', value: 'afflictionId', table: () => import('../tables/BiosecurityIncidentsTable') },
                ],
                mainForm: () => import('../forms/AfflictionForm'),
                claimName: 'Afflictions',
                apiMethod: 'Afflictions',
            }
        }
    };
</script>
